import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './nav.css';

const HomeIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 3l9 8h-3v9h-5v-6H11v6H6v-9H3l9-8z" />
    </svg>
);

const DesignerIcon = () => (
    <svg viewBox="0 0 17 17" fill="currentColor">
        <path d="M11.2756 14.7998V13.3903C11.2756 12.6426 10.9786 11.9256 10.45 11.397C9.9213 10.8683 9.20428 10.5713 8.45664 10.5713H4.22816C3.48052 10.5713 2.7635 10.8683 2.23484 11.397C1.70618 11.9256 1.40918 12.6426 1.40918 13.3903V14.7998" stroke="currentColor" strokeWidth="1.40949" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <path d="M6.34242 7.75222C7.8993 7.75222 9.1614 6.49012 9.1614 4.93324C9.1614 3.37636 7.8993 2.11426 6.34242 2.11426C4.78554 2.11426 3.52344 3.37636 3.52344 4.93324C3.52344 6.49012 4.78554 7.75222 6.34242 7.75222Z" stroke="currentColor" strokeWidth="1.40949" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <path d="M15.5039 14.7995V13.39C15.5034 12.7654 15.2955 12.1586 14.9129 11.665C14.5302 11.1713 13.9944 10.8187 13.3896 10.6626" stroke="currentColor" strokeWidth="1.40949" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <path d="M11.2754 2.20557C11.8818 2.36082 12.4192 2.71348 12.803 3.20793C13.1868 3.70239 13.3952 4.31052 13.3952 4.93646C13.3952 5.56239 13.1868 6.17052 12.803 6.66498C12.4192 7.15943 11.8818 7.51209 11.2754 7.66735" stroke="currentColor" strokeWidth="1.40949" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
);

const ScheduleIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 2v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2V2h-2v2H9V2H7zm12 18H5V9h14v11z" />
    </svg>
);

const TicketIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M4 10v4a2 2 0 110 4v2h16v-2a2 2 0 110-4v-4a2 2 0 110-4V4H4v2a2 2 0 110 4z" />
    </svg>
);

const LINKS = [
    { to: '/home',      Icon: HomeIcon,     label: 'home'     },
    { to: '/designers', Icon: DesignerIcon, label: 'designers'},
    { to: '/schedule',  Icon: ScheduleIcon, label: 'schedule' },
    { to: '/tickets',   Icon: TicketIcon,   label: 'tickets'  },
];

const Nav = () => {
    const [open, setOpen]         = useState(true);
    const [scrolling, setScrolling] = useState(false);
    const [rippling, setRippling]   = useState(false);
    const location                  = useLocation();
    const openTimer                 = useRef(null);
    const rippleTimer               = useRef(null);
    const prevOpen                  = useRef(true);

    // Trigger ripple once when nav re-opens
    useEffect(() => {
        if (open && !prevOpen.current) {
            setRippling(true);
            clearTimeout(rippleTimer.current);
            rippleTimer.current = setTimeout(() => setRippling(false), 600);
        }
        prevOpen.current = open;
    }, [open]);

    // Scroll detection
    useEffect(() => {
        const container = document.querySelector('.hcontainer') || window;

        const handleScroll = () => {
            setOpen(false);
            setScrolling(true);

            clearTimeout(openTimer.current);
            openTimer.current = setTimeout(() => {
                setOpen(true);
                setScrolling(false);
            }, 380);
        };

        container.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            container.removeEventListener('scroll', handleScroll);
            clearTimeout(openTimer.current);
            clearTimeout(rippleTimer.current);
        };
    }, []);

    // Tap-to-toggle when collapsed
    const handleDotClick = useCallback(() => {
        if (!open) setOpen(true);
    }, [open]);

    const navClass = [
        'dotnav',
        open     ? 'open'     : '',
        rippling ? 'rippling' : '',
    ].filter(Boolean).join(' ');

    const wrapClass = ['bottomnav', scrolling ? 'scrolling' : ''].filter(Boolean).join(' ');

    return (
        <div className={wrapClass}>
            <div className={navClass} onClick={handleDotClick}>
                <div className="navitems">
                    {LINKS.map(({ to, Icon, label }) => (
                        <Link
                            key={to}
                            to={to}
                            className={location.pathname === to ? 'active' : ''}
                            aria-label={label}
                        >
                            <Icon />
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Nav;